export const COMPANY = {
	CREATE_COMPANY: 'Create Company',
	EDIT_COMPANY: 'Edit Company',
	DELETE_COMPANY: 'Delete Company',
	VIEW_AS: 'View As',
};
